/* eslint-disable prettier/prettier -- this is a generated file */
// NOTE: This file is generated by running the following:
//   ./libs/dev/i18n/src/update-moment-locales.ts
// DO NOT EDIT THIS FILE MANUALLY.
export const loadMomentLocaleData = (locale: string) => {
    switch (locale) {
        case "ar": return require("moment/locale/ar.js");
        case "az": return require("moment/locale/az.js");
        case "bg": return require("moment/locale/bg.js");
        case "bn": return require("moment/locale/bn.js");
        case "cs": return require("moment/locale/cs.js");
        case "da": return require("moment/locale/da.js");
        case "de": return require("moment/locale/de.js");
        case "el": return require("moment/locale/el.js");
        case "es": return require("moment/locale/es.js");
        case "fa": return require("moment/locale/fa.js");
        case "fr": return require("moment/locale/fr.js");
        case "gu": return require("moment/locale/gu.js");
        case "he": return require("moment/locale/he.js");
        case "hi": return require("moment/locale/hi.js");
        case "hu": return require("moment/locale/hu.js");
        case "hy-am": return require("moment/locale/hy-am.js");
        case "id": return require("moment/locale/id.js");
        case "is": return require("moment/locale/is.js");
        case "it": return require("moment/locale/it.js");
        case "ja": return require("moment/locale/ja.js");
        case "ka": return require("moment/locale/ka.js");
        case "kk": return require("moment/locale/kk.js");
        case "km": return require("moment/locale/km.js");
        case "kn": return require("moment/locale/kn.js");
        case "ko": return require("moment/locale/ko.js");
        case "ky": return require("moment/locale/ky.js");
        case "lt": return require("moment/locale/lt.js");
        case "lv": return require("moment/locale/lv.js");
        case "mn": return require("moment/locale/mn.js");
        case "mr": return require("moment/locale/mr.js");
        case "ms": return require("moment/locale/ms.js");
        case "my": return require("moment/locale/my.js");
        case "nb": return require("moment/locale/nb.js");
        case "nl": return require("moment/locale/nl.js");
        case "pl": return require("moment/locale/pl.js");
        case "pt": return require("moment/locale/pt.js");
        case "pt-br": return require("moment/locale/pt-br.js");
        case "ro": return require("moment/locale/ro.js");
        case "ru": return require("moment/locale/ru.js");
        case "sk": return require("moment/locale/sk.js");
        case "sq": return require("moment/locale/sq.js");
        case "sr-cyrl": return require("moment/locale/sr-cyrl.js");
        case "sv": return require("moment/locale/sv.js");
        case "sw": return require("moment/locale/sw.js");
        case "ta": return require("moment/locale/ta.js");
        case "te": return require("moment/locale/te.js");
        case "th": return require("moment/locale/th.js");
        case "tr": return require("moment/locale/tr.js");
        case "uk": return require("moment/locale/uk.js");
        case "ur": return require("moment/locale/ur.js");
        case "uz-latn": return require("moment/locale/uz-latn.js");
        case "vi": return require("moment/locale/vi.js");
        case "zh-cn": return require("moment/locale/zh-cn.js");
        case "zh-tw": return require("moment/locale/zh-tw.js");
        default: return null;
    }
};
